import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'; // NavLink
import './App.css';
import Main from "./components/Main";
import Restaurant from "./components/Restaurant";

class App extends Component {
	render() {
		return (
			<main>
				{/* <div >   
					<NavLink to={`/`} activeClassName="active">Home</NavLink>
				</div> */}
				<Switch>
					<Route path={`/`} exact component={Main} />
					<Route path={`/restaurant/:slug`} component={Restaurant} />
					<Redirect to='/' />;
				</Switch>
			</main>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js